// Machine-drafted — review with a native speaker before launch.
const schedule = {
	schedule: {
		// Shared
		cancel: 'إلغاء',
		next: 'التالي',
		continue: 'متابعة',
		loading: 'جارٍ التحميل ...',
		edit: 'تعديل',
		yes: 'نعم',
		no: 'لا',
		add: 'إضافة',
		update: 'تحديث',
		errorTitle: 'خطأ',
		oops: 'عذرًا!',
		searchRecipients: 'البحث عن المستلمين',

		// Header
		editCard: 'تعديل البطاقة',

		// Progress bar / steps
		progress: 'التقدم',
		step1: 'الخطوة 1',
		step2: 'الخطوة 2',
		step3: 'الخطوة 3',
		letsSendYourCard: 'لنرسل بطاقتك',
		stepAddRecipients: 'أضف بعض المستلمين',
		stepConnectEmail: 'اربط حساب بريدك الإلكتروني',
		stepCustomizeSubject: 'خصّص سطر الموضوع',

		// Sender detail / email account
		selectEmailAccount: 'اختر حساب بريد إلكتروني',
		selectPreferredEmail: 'اختر حساب البريد الإلكتروني المفضل لديك لإرسال البطاقات منه.',
		noEmailAccounts: 'لا توجد حسابات بريد إلكتروني لعرضها',
		addNewEmailAccount: '+ إضافة حساب بريد إلكتروني جديد',
		confirmEmailAccount: 'تأكيد حساب البريد الإلكتروني',
		sendUsingDefaultTitle: 'الإرسال باستخدام نظام البريد الافتراضي لدينا',
		sendViaDefault: 'الإرسال عبر عنوان البريد الإلكتروني الافتراضي',
		connectPersonalEmail: 'يرجى ربط عنوان بريدك الإلكتروني الشخصي',
		orSendDefaultAccount: 'أو الإرسال باستخدام حسابنا الافتراضي.',
		selectCustomEmailError:
			'يرجى اختيار حساب بريد إلكتروني مخصص لجدولة البطاقة أو اختيار خيار الإرسال باستخدام بريدنا الافتراضي.',
		planNoCustomEmail: 'خطتك لا تسمح بإضافة حسابات بريد إلكتروني مخصصة. يرجى ترقية خطتك',
		emailAccountsLimitReached: 'لقد وصلت إلى حد حسابات البريد الإلكتروني. يرجى ترقية خطتك لإضافة المزيد من الحسابات',

		// Add recipient intro / empty state
		addRecipientsIntro: 'يمكنك إضافة المستلمين بشكل فردي أو استيراد قائمة جهات اتصال عن طريق رفع ملف CSV مجمّع',
		noRecipientsYet: 'ليس لديك مستلمون بعد.',
		addNamesEmails: 'أضف أسماء وعناوين البريد الإلكتروني لمستلمي بطاقتك.',
		uploadCsv: 'رفع ملف CSV',
		addRecipient: 'إضافة مستلم',

		// Contact list
		prepareContactList: 'لنجهّز قائمة جهات اتصالك',
		fileUploadedPrepare: 'تم رفع ملفك بنجاح. لنجهّزه الآن لتخصيص البطاقات',
		contactListTitle: 'عنوان قائمة جهات الاتصال',
		whatIsContactList: 'ما هي قائمة جهات الاتصال؟',
		contactListDescription:
			'قائمة جهات الاتصال هي دفتر عناوين يمكنك استخدامه في أي وقت لإرسال بطاقات مخصصة ومجمّعة',
		noCsvSelected: 'لم يتم اختيار ملف csv',

		// Merge tags
		selectMergeTags: 'اختر علامات الدمج',
		whatIsMergeTag: 'ما هي علامة الدمج؟',
		mergeTagDescription:
			'علامات الدمج هي علامات مخصصة مرتبطة ببياناتك المجمّعة لتخصيص المستندات والرسومات وما إلى ذلك.',
		enterTagName: 'أدخل اسم العلامة',
		addNewMergeTagBtn: 'إضافة علامة دمج جديدة',
		duplicateMergeTag: 'لا يمكن إضافة علامة دمج بنفس الاسم.',

		// Upload CSV modal
		uploadCsvHere: 'ارفع ملف CSV الخاص بك هنا',
		uploadCsvDescription:
			'بمجرد رفع ملف CSV الخاص بك، سيقوم %{app} بربط بياناتك بعلامات الدمج المتاحة إلى جانب العلامات المخصصة لتخصيص كل بطاقة وإرسال البطاقات إلى أي عدد تريده من جهات الاتصال',
		downloadCsvTemplate: 'تنزيل قالب CSV',
		csvColumnsLabel: 'الأعمدة:',
		csvExtraColumns: '. تصبح الأعمدة الإضافية علامات دمج.',
		csvExampleLabel: 'مثال:',
		changeFile: 'تغيير الملف',
		csvFileLabel: 'ملف CSV',
		clickToUpload: 'انقر لرفع ملف csv الخاص بك',

		// Recipients table / list
		recipientsHeader: 'المستلمون',
		missingFields: 'حقول ناقصة',
		errorsCount: '%{count} خطأ',
		invalidRecipientEmails: 'عناوين بريد إلكتروني غير صالحة للمستلمين',
		invalidEmailsCount: '%{count} بريد إلكتروني غير صالح',
		fromLabel: 'من',
		listSuffix: 'قائمة',
		addNewRecipient: 'إضافة مستلم جديد',
		copyCardUrl: 'نسخ رابط البطاقة',
		scheduleForLater: 'الجدولة لوقت لاحق',
		saveAndNext: 'حفظ والتالي',
		selectAll: 'تحديد الكل',
		unnamed: 'بدون اسم',
		noRecipientsFound: 'لم يتم العثور على مستلمين.',

		// Toasts / swal (recipients)
		updatedRecipientSuccess: 'تم تحديث المستلم بنجاح',
		addedRecipientSuccess: 'تمت إضافة المستلم بنجاح',
		decrementLimitByCount: 'سيقلل هذا الإجراء حد المستلمين لديك بمقدار %{count}!',
		decrementLimit: 'سيقلل هذا الإجراء حد المستلمين لديك!',
		linkCopied: 'تم نسخ الرابط بنجاح',

		// Copy card URL modal
		getCardUrls: 'الحصول على روابط البطاقة',
		copyUrlDescription:
			'يمكنك نسخ رابط المستلمين وإرساله إليهم مباشرة عبر أي وسيلة مثل ماسنجر أو واتساب وغيرها.',
		downloadAsCsv: 'تنزيل كملف CSV',
		copyUrl: 'نسخ الرابط',
		noRecipientsToCopy: 'لا يوجد مستلمون لنسخهم.',

		// Schedule modals
		scheduleCard: 'جدولة البطاقة',
		addDateTimeDescription:
			'لنضِف التاريخ والوقت الذي تريد أن يستلم فيه جهات اتصالك البطاقة. يمكنك أيضًا تغيير الجدولة يدويًا لكل مستلم.',
		selectDateTime: 'اختر التاريخ والوقت',
		missingData: 'بيانات ناقصة',
		missingDataDescription: 'لديك بعض البيانات الناقصة في الأعمدة قد تسبب مشكلة في إرسال البطاقات.',
		updateData: 'تحديث البيانات',
		skipContinue: 'تخطي والمتابعة',

		// Add recipient modal / form
		recipientInfo: 'معلومات المستلم',
		updateRecipientInfoDesc: 'حدّث معلومات مستلميك حتى يستلموا البطاقة بشكل صحيح.',
		addNameEmailDesc: 'أضف اسم وعنوان البريد الإلكتروني للمستلم',
		basicInfo: 'المعلومات الأساسية',
		nameLabel: 'الاسم',
		emailLabel: 'البريد الإلكتروني',
		nameOfRecipient: 'اسم المستلم',
		mergeTagsLabel: 'علامات الدمج',
		recurring: 'متكرر',
		yearly: 'سنوي',
		monthly: 'شهري',
		weekly: 'أسبوعي',
		daily: 'يومي',

		// Customize subject / preview
		whoIsCardFrom: 'ممن هذه البطاقة',
		recipientsLeft: 'تبقّى لديك %{count} مستلم',
		unlimitedRecipients: 'لديك عدد غير محدود من مستلمي البريد الإلكتروني',
		customizeSubjectEmail: 'خصّص موضوع البريد الإلكتروني.',
		customizeHeader: 'خصّص رأس معاينة البطاقة',
		customizeFooter: 'خصّص تذييل معاينة البطاقة',
		addCta: 'إضافة زر إجراء في بطاقة المعاينة',
		toggleConfetti: 'تبديل القصاصات الورقية',
		howCardLooksEmail: 'كيف تبدو البطاقة في البريد الإلكتروني؟',
		howCardLooksViewScreen: 'كيف تبدو البطاقة في شاشة عرض البطاقة؟',
		enterSenderName: 'أدخل اسم المرسل',
		subjectLinePlaceholder: 'مرحبًا %{tag}، أنشأ %{name} بطاقة رقمية لك.',
		subjectLineFromPlaceholder: 'مرحبًا %{tag}، من %{name} أنشأ بطاقة رقمية لك.',
		cardPreviewHeaderPlaceholder: 'رأس معاينة البطاقة',
		cardPreviewFooterPlaceholder: 'تذييل معاينة البطاقة',
		unsubscribeTextPlaceholder: 'نص رابط إلغاء الاشتراك (اختياري)',
		ctaTextLabel: 'نص',
		ctaPlaceholder: 'انقر هنا',
		subjectLineHint: 'أضف اسم مرسل مفضل وسطر موضوع. يمكنك أيضًا إضافة علامات دمج في سطر الموضوع',

		// Scheduled recipients table / fallback date
		cardsReadyToSchedule: 'البطاقة (البطاقات) جاهزة للجدولة',
		manualScheduleHint: 'يمكنك تغيير جدولة كل بطاقة يدويًا إذا رغبت في ذلك',
		sendDateFallbackLabel: 'تاريخ الإرسال للمستلمين الذين ليس لديهم تاريخ في ملف CSV',
		fallbackHintCsv:
			'المستلمون الذين لديهم schedule_date صالح في ملف CSV يحتفظون بتاريخهم الخاص. ينطبق هذا التاريخ الاحتياطي على الجميع.',
		fallbackHintNoCsv: 'يطبّق هذا التاريخ على كل مستلم. تجاوز الصفوف الفردية في الجدول أدناه.',
		pickFallbackDate: 'اختر تاريخًا احتياطيًا',
		applyScheduleDates: 'تطبيق تواريخ الجدولة',
		sendCard: 'إرسال البطاقة',
		scheduledAt: 'مجدول في',
		now: 'الآن',
		noSelectedRecipients: 'لم يتم العثور على مستلمين محددين.',

		// Email preview
		emailFooterDefault: 'وصلت إلى صندوق بريدك للتو رسالة خاصة. اعرض بطاقتك عبر الإنترنت.',
		viewCard: 'عرض البطاقة',
		unsubscribe: 'إلغاء الاشتراك',

		// Toasts / swal (schedule / apply)
		cardScheduledSuccess: 'تمت جدولة البطاقة!',
		saveCardProblem: 'حدثت مشكلة أثناء حفظ بطاقتك. يرجى المحاولة مرة أخرى.',
		pickFallbackOrCsv: 'اختر تاريخ إرسال احتياطيًا أو ارفع ملف CSV يحتوي على عمود schedule_date.',
		scheduleAppliedCount: 'تم تطبيق الجدولة على %{count} مستلم.',
		applyScheduleFailed: 'فشل تطبيق تواريخ الجدولة. يرجى المحاولة مرة أخرى.',
	} as Record<string, string>,
};
export default schedule;
